import $ from 'jquery';

$(function(){
  const $messagesButton = $('#messages-button');
  $messagesButton.click(function(){
    $.ajax({
      url: `/api/buyside/user/message_views/${$messagesButton.data('userId')}`,
      method: 'PUT',
      data: {date: new Date()}
    });
    $messagesButton.find('.tinyBadge--notification').hide();
  })
})
